import { defineStore } from 'pinia'
import { defaultState, defaultActions } from './_global'

export const useArticlesStore = defineStore('articlesStore', {
  state: () => ({
    endpoint: 'articles',
    ...defaultState
  }),
  actions: {
    ...defaultActions
  }
})
